import _sliceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/slice";import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";import React from 'react';
import { Castle, ChevronDown } from "../../../icons";
import { Tooltip } from "../..";

import { AlignmentTypes } from "../../../types/Tooltip";
import { eeRights } from "../../../utils/accessRights";
import { createStyles } from "./styles";

var UserInfoSection = function UserInfoSection(params) {var _context;
  var firstName = params.firstName,lastName = params.lastName,affiliation = params.affiliation,onClick = params.onClick,customMainColor = params.customMainColor,_params$sandbox = params.sandbox,sandbox = _params$sandbox === void 0 ? false : _params$sandbox;
  var keyPressHandler = function keyPressHandler(e) {
    if (e.keyCode === 13 && onClick) {
      onClick();
    }
  };
  var classes = createStyles({ customMainColor: customMainColor });
  return /*#__PURE__*/(
    React.createElement("div", {
      className: classes.userAccountWrapper,
      onClick: onClick,
      onKeyDown: keyPressHandler,
      role: "button",
      tabIndex: 0 }, /*#__PURE__*/

    React.createElement("div", { className: classes.userPreview }, /*#__PURE__*/
    React.createElement("span", { className: classes.userPreviewText },
    _sliceInstanceProperty(firstName).call(firstName, 0, 1),
    _sliceInstanceProperty(lastName).call(lastName, 0, 1))), /*#__PURE__*/


    React.createElement("div", { className: classes.userInfo }, /*#__PURE__*/
    React.createElement("h3", { className: classes.userName }, _concatInstanceProperty(_context = "".concat(firstName, " ")).call(_context, lastName)),
    !eeRights(params.currentUserRoles) && /*#__PURE__*/
    React.createElement(Tooltip, { label: affiliation, alignment: AlignmentTypes.LEFT_END }, /*#__PURE__*/
    React.createElement("div", { className: classes.affiliationWrapper },
    sandbox && /*#__PURE__*/
    React.createElement("span", { className: classes.sandboxIconWrapper }, /*#__PURE__*/
    React.createElement(Castle, { width: "2rem", height: "2rem" })), /*#__PURE__*/


    React.createElement("h4", { className: classes.userPosition }, affiliation)))), /*#__PURE__*/




    React.createElement(ChevronDown, { width: "4rem", height: "4rem", className: classes.openIcon })));


};

export default UserInfoSection;
//# sourceMappingURL=index.js.map